import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "movie" }
const _hoisted_2 = { class: "movie-form-tree" }
const _hoisted_3 = ["onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys($props.schema).filter((k) => k !== 'movie'), (type) => {
        return (_openBlock(), _createBlock($setup["AccordionItem"], {
          id: $setup.getSectionId(type),
          key: type,
          title: type
        }, {
          "header-actions": _withCtx(() => [
            _createElementVNode("button", {
              class: "icon",
              onClick: $event => ($setup.openEntityModal('add', type, null, $props.movie, $props.movie, type))
            }, "library_add", 8 /* PROPS */, _hoisted_3)
          ]),
          default: _withCtx(() => [
            _createVNode($setup["RelationSection"], {
              relation: { name: type, type: type, many: true },
              parent: $props.movie,
              "parent-movie": $props.movie,
              schema: $props.schema,
              "open-entity-modal": $setup.openEntityModal,
              "on-delete-entity": () => {},
              onUpdate: $setup.handleMovieUpdate
            }, null, 8 /* PROPS */, ["relation", "parent", "parent-movie", "schema"])
          ]),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id", "title"]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    ($props.movie)
      ? (_openBlock(), _createBlock($setup["AppSidebar"], {
          key: 0,
          movie: $props.movie,
          schema: $props.schema
        }, null, 8 /* PROPS */, ["movie", "schema"]))
      : _createCommentVNode("v-if", true),
    ($setup.entityModalState && $setup.entityModalState.open)
      ? (_openBlock(), _createBlock($setup["EntityModal"], {
          key: 1,
          "is-open": $setup.entityModalState.open,
          mode: $setup.entityModalState.mode,
          type: $setup.entityModalState.type,
          entity: $setup.entityModalState.entity,
          parent: $setup.entityModalState.parent,
          "parent-movie": $setup.entityModalState.parentMovie,
          "relation-name": $setup.entityModalState.relationName,
          "on-submit": $setup.entityModalState.onSubmit,
          schema: $props.schema,
          onSubmit: $setup.handleEntityModalSubmit,
          onClose: $setup.closeEntityModal
        }, null, 8 /* PROPS */, ["is-open", "mode", "type", "entity", "parent", "parent-movie", "relation-name", "on-submit", "schema"]))
      : _createCommentVNode("v-if", true)
  ]))
}